module.exports = __webpack_public_path__ + "static/media/Stripo.29ed642e.png";